import FaqAccordion from '../../molecules/FaqAccordion';

const FormFaqSection = ({ faqs = [], faqTitle = '' }) => {
  return (
    <section data-testid="faq-section">
      {/* FAQ Section */}
      <div className="border-t-4">
        <FaqAccordion faqs={faqs} title={faqTitle} />
      </div>
    </section>
  );
};

export default FormFaqSection;
